import { render, staticRenderFns } from "./GinCreate.vue?vue&type=template&id=2da980cf&scoped=true"
import script from "./GinCreate.vue?vue&type=script&lang=js"
export * from "./GinCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da980cf",
  null
  
)

export default component.exports